import React, { useEffect } from 'react'
import { Box } from '@sainsburys-tech/fable'
import { Offer, ChevronRight } from '@sainsburys-tech/icons'
import { InView } from 'react-intersection-observer'
import { pushEventAndTrack } from '@/javascript/helpers/taggingSerializer'

const TradeOffer = () => {
  const trackEvent = (eventAction, eventName) => {
    pushEventAndTrack({
      eventInfo: {
        eventAction,
        eventName
      }
    })
  }

  useEffect(() => {
    trackEvent('trade-in panel:content loaded', 'trade-in panel')
  }, [])

  const handleInView = inView => {
    if (inView) {
      trackEvent('trade-in panel:content viewed', 'trade-in panel')
    }
  }

  const handleClick = () => {
    trackEvent('trade-in panel:cta clicked', 'trade-in panel')
  }

  return (
    <InView triggerOnce as='div' onChange={handleInView} threshold={0.5}>
      <div className='top-border'>
        <a
          href='https://www.argos-tradein.co.uk/'
          target='_blank'
          rel='noopener noreferrer'
          style={{ textDecoration: 'none' }}
          onClick={handleClick}
        >
          <Box className='trade-offer-container' as='div' border={{ radius: 'lg', size: 'sm' }}>
            <div className='ds-flex ds-items-center ds-gap-1 ds-text-green-600 ds-font-semibold ds-text-sm'>
              <Offer className='offer-icon' />
              <span>Trade in your old phone.</span>
              <ChevronRight className='chevron-icon-right' />
            </div>
            <div className='ds-mx-[1.75rem] ds-text-black ds-text-sm ds-font-normal'>
              Receive between <strong>£19 - £320.</strong> Get your estimated value here
            </div>
          </Box>
        </a>
      </div>
    </InView>
  )
}

export default TradeOffer
